import React, { useEffect, useState, useGlobal } from 'reactn';
import { DropDownButtonStyled } from './DropDownButtonStyled';
import Icon from '../../_common/icons/ReturnIcons';
import checkMark from '../../_common/icons/checkMark.svg';
import SidePanel from '../../_common/sidePanel/sidePanel';
import ForAnotherDayForm from '../sidePanelForms/forAnotherDay';
import SafeSpotForm from '../sidePanelForms/safeSpot';
import ToNeighbourForm from '../sidePanelForms/neighbour';
import MainPage from '../../_pages/_parcelLocker/main/MainPage';
import { getDeliveryManager, getTrackingHistory } from '../../../services/Api';
import profileHooks from '../../../hooks/profileHooks';


const DropDownButton = ({ dropDownItems, deliveryManagerResults }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeBar, setActiveBar] = useState(null);
    const [isCollectionPointFinderActive, setIsCollectionPointFinderActive] = useGlobal("isCollectionPointFinderActive");
    const [isParcelLockerFinderActive, setIsParcelLockerFinderActive] = useGlobal("isParcelLockerFinderActive");
    const [successfullApiCall, setSuccessfullApiCall] = useGlobal("successfullApiCall");

    const toggleList = () => {
        setIsOpen(!isOpen);
    };

    const removeDuplicatePostOptions = (options) => {
        const hasPostOffice = options.some(option => option.value === 'POST_OFFICE');
        const hasPostPoint = options.some(option => option.value === 'POST_POINT');

        if (hasPostOffice && hasPostPoint) {
            return options.filter(option => option.value !== 'POST_POINT');
        }

        return options;
    };

    const handleClick = (value) => {
        switch (value) {
            case 'SAFE_PLACE':
                setIsModalOpen(true);
                setActiveBar(<SafeSpotForm deliveryManagerResults={deliveryManagerResults} />);
                setIsOpen(false);
                break;
            case 'SPECIFIED_NEIGHBOUR':
                setIsModalOpen(true);
                setActiveBar(<ToNeighbourForm deliveryManagerResults={deliveryManagerResults} />);
                setIsOpen(false);
                break;
            case 'POST_OFFICE' || 'POST_POINT':
                setIsCollectionPointFinderActive(true);
                setIsOpen(false);
                break;
            case 'ALTERNATIVE_DAY':
                setIsModalOpen(true);
                setActiveBar(<ForAnotherDayForm deliveryManagerResults={deliveryManagerResults} />);
                setIsOpen(false);
                break;
            case 'LOCKER':
                setIsParcelLockerFinderActive(true);
                setIsOpen(false);
                break;
            default:
                break;
        }
    }

    return (
        <>
            {isCollectionPointFinderActive || isParcelLockerFinderActive ? <MainPage /> : <DropDownButtonStyled toggeled={isOpen} radioContent={checkMark} borderColor={"#00A76A"}>
                <div className='contentWrapper gtm-cta'>
                    <div className='title'>
                        Manage Delivery
                    </div>
                    <button onClick={toggleList} className='gtm-cta'>
                        Options <Icon src="arrowUpDownIcon" />
                    </button>
                </div>
                {isOpen && (
                    <div className='list gtm-cta'>
                        {removeDuplicatePostOptions(dropDownItems).sort((a, b) => a.order - b.order)
                            .map((item, index) => <span key={index} className='listItem gtm-cta' onClick={() => handleClick(item.value)}>{item.label}</span>)}
                    </div>
                )}

                <SidePanel isOpen={isModalOpen} onClose={() => {
                    setSuccessfullApiCall(false)
                    setIsModalOpen(false)
                }} >
                    {activeBar}
                </SidePanel>
            </DropDownButtonStyled>}
        </>
    );
};

export default DropDownButton;